import { GuardianSimple, GuardianSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

export const useGuardiansQuery = (patientId: number): UseCqrsQueryResult<GuardianSimple[]> => {
   return useCqrsSearch(() => {
      const query = new GuardianSimpleQuery();
      query.patientId = Slot.of(patientId);
      return query;
   });
};
